import { Injectable, signal } from '@angular/core';
import { Tercero } from '../models';
import { FACTORES } from '../mocks/datos';

/**
 * Dimensión "factor" del panel (Análisis §4/§7: convivencia multi-factor).
 * Mantiene el factor seleccionado como filtro transversal. `null` = todos los factores.
 *
 * Aunque el MVP opere solo con LIQUITECH, el filtro existe desde el día uno para no
 * asumir un único factor.
 */
@Injectable({ providedIn: 'root' })
export class FactorService {
  /** Factores disponibles (proyección local de terceros tipo 'factor'). */
  readonly factores = signal<Tercero[]>(FACTORES);

  /** Id del factor seleccionado; `null` significa "todos". */
  readonly factorSeleccionado = signal<number | null>(null);

  seleccionar(factorId: number | null): void {
    this.factorSeleccionado.set(factorId);
  }

  nombre(factorId: number | null): string {
    if (factorId == null) return 'Todos los factores';
    return this.factores().find((f) => f.id === factorId)?.nombre ?? 'Factor';
  }
}
